import React from 'react';
import styled from 'styled-components';

export const getItemsStyle = (items: number, margin: number, oneRow: any) => `
  width: calc((100% - ${margin * (items - 1)}px)/${items});
  &:nth-child(n) {
    margin-right: ${margin}px;
  }

  ${
    !oneRow &&
    `&:nth-child(${items}n) {
      margin-right: 0px;
    }`
  }
`;

export const CourseCardWrapper = styled(
  ({ itemsPerRow, onRow, oneRow, isMobile, ...rest }) => <div {...rest} />,
)`
  width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;
  ${props => {
    if (props.isMobile) {
      return `
        &:not(:last-child) {
          margin-bottom: 40px;
        }
      `;
    }

    return 'margin-bottom: 40px;';
  }}

  @media (min-width: 600px) {
    ${props => getItemsStyle(2, 16, props.oneRow)};
  }

  @media (min-width: 768px) {
    ${props => getItemsStyle(props.itemsPerRow['768'] || 3, 16, props.oneRow)};
  }

  @media (min-width: 1024px) {
    ${props => getItemsStyle(props.itemsPerRow['1024'] || 3, 24, props.oneRow)}
  }

  @media (min-width: 1280px) {
    ${props => getItemsStyle(props.itemsPerRow['1280'] || 3, 24, props.oneRow)}
    margin-bottom: 40px;
  }

  @media (min-width: 1440px) {
    ${props => getItemsStyle(props.itemsPerRow['1440'] || 3, 24, props.oneRow)}
  }

  @media (min-width: 1680px) {
    ${props => getItemsStyle(props.itemsPerRow['1680'] || 4, 24, props.oneRow)}
  }
`;
